import { TOGGLE_MINI_CART } from './types';

const toggleMiniCart = (state, { open }) => {
  const openIsUndefined = typeof open === 'undefined';

  return {
    ...state,
    ...!openIsUndefined && {
      isOpen: open,
    },
    ...openIsUndefined && {
      isOpen: !state.isOpen,
    },
  };
};

const reducer = {
  [TOGGLE_MINI_CART]: toggleMiniCart,
};

const initialState = {};

export default (state = initialState, action) =>
  (action.type && reducer[action.type] ? reducer[action.type](state, action) : state);
